import HTTP from "../HTTP";
import Jsona from "jsona";

import helpers from "../helpers/coupons";

const dataFormatter = new Jsona();

export default {
  async index(number_page, field_sort, text_search) {
    try {
      let search = "";
      let page = `&page[number]=${number_page}`;
      let sort = "";

      if (text_search.length >= 3) search = `&filter[name]=${text_search}`;

      let results = await HTTP.normal.get(
        `/coupons?include=districts.pricing,districts.city,districts.rating${search}${page}${sort}`
      );

      return {
        data: dataFormatter.deserialize(results.data),
        meta: results.data.meta
      };
    } catch (e) {
      throw "Ocorreu um erro ao listar os cupons!";
    }
  },

  async create(payload) {
    const data = helpers.createRequestBody(payload);

    try {
      return await HTTP.normal.post("/coupons", data);
    } catch (error) {
      throw error.response.data.errors.map(err => err.detail);
    }
  },

  async addDistricts(payload) {
    const data = helpers.addDistrictBody(payload);
    try {
      return await HTTP.normal.patch(`/coupons/${payload.coupon_id}`, data);
    } catch (e) {
      throw "Erro ao relacionar distritos ao cupom";
    }
  },

  async getById(id) {
    try {
      let result = await HTTP.normal.get(`/coupons/${id}`);
      return dataFormatter.deserialize(result.data);
    } catch (e) {
      throw "Ocorreu um erro ao buscar o cupom!!";
    }
  },

  async update(payload) {
    const data = helpers.updateRequestBody(payload);

    try {
      return await HTTP.normal.patch(`/coupons/${payload.id}`, data);
    } catch (error) {
      throw error.response.data.errors.map(err => err.detail);
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/coupons.js